import React from 'react'
import { Card } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate, getParsedPhoneNumber } from 'src/utils'
import { accountsContainer, customerContainer } from 'src/models'
import { accountTypeTranslation } from 'src/deps'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import './styles.scss'

@observer
class EventStaticAccountProfile extends React.Component {
  @observable sponsorId = 'RETFLOAT'
  @observable sponsorName = ''
  @observable dataForEventAccountProfile = [
    {
      label: 'sponsorChange.current',
      value: '-',
    },
    {
      label: 'sponsorChange.affiliateName',
      value: '-',
    },
  ]
  @observable dataForAccountInformation = [
    {
      label: 'profileData.name',
      value: '-',
    },
    {
      label: 'emailAddressPlaceHolder',
      value: '-',
    },
    {
      label: 'phoneNoPlaceHolder',
      value: '-',
    },
  ]

  async componentDidMount() {
    await this.getDataForAccountType()
    await this.getDataForAccountInformation()
  }

  getDataForAccountType = async () => {
    await customerContainer?.getProfile()
    const accountId = customerContainer?.profileResponse?.accounts?.id || ''
    await accountsContainer?.getProfile(accountId)
    const accProperties = accountsContainer?.profileResponse?.properties
    const spid =
      accProperties &&
      accProperties.find(list => list.attributeId === 'sponsorId')
    const sponsorId = spid?.value || ''
    this.sponsorId = sponsorId

    if (sponsorId !== 'RETFLOAT') {
      this.sponsorName = await customerContainer?.sponsorIdValidation(sponsorId)
    }

    this.dataForEventAccountProfile = [
      {
        label: 'sponsorChange.current',
        value:
          accountTypeTranslation(
            customerContainer?.profileResponse?.accounts?.accountType
          ) || '-',
      },
      {
        label: 'sponsorChange.affiliateName',
        value:
          this.sponsorId !== 'RETFLOAT'
            ? this.sponsorName.firstName || this.sponsorName.lastName
              ? (this.sponsorName.firstName || '') +
                ' ' +
                (this.sponsorName.lastName || '')
              : '-'
            : i18nTranslate('sponsorChange.pendingSponsor', 'Pending Sponsor'),
      },
    ]
  }

  getDataForAccountInformation = async () => {
    let addressData = customerContainer?.profileResponse
    let accountParsedPhoneNumber = await getParsedPhoneNumber(
      addressData?.phoneNumber || ''
    )
    let countryPhoneData = countryData().filter(
      item => item.value === accountParsedPhoneNumber?.phoneCountry
    )
    this.dataForAccountInformation = [
      {
        label: 'profileData.name',
        value:
          addressData?.firstName || addressData?.lastName
            ? (addressData?.firstName || '') +
              ' ' +
              (addressData?.lastName || '')
            : '-',
      },
      {
        label: 'emailAddressPlaceHolder',
        value: addressData?.email || '-',
      },
      {
        label: 'phoneNoPlaceHolder',
        value:
          countryPhoneData[0]?.displayValue &&
          accountParsedPhoneNumber?.phoneNumberCode
            ? (countryPhoneData[0]?.displayValue || '') +
              ' ' +
              (accountParsedPhoneNumber?.phoneNumberCode || '')
            : '-',
      },
    ]
  }

  renderAccountInformation = () => {
    const homeCountry = customerContainer?.getUserHomeCountry()
    return (
      <div className="event-profile-account-information">
        <h1 className="event-profile-title">
          {i18nTranslate(
            'accountProfile.lglAddressTitle',
            'Account Information'
          )}
        </h1>
        {homeCountry !== 'CN' && this.renderEditInfo()}
        {this.dataForAccountInformation &&
          this.dataForAccountInformation.map(field => (
            <div className="event-profile-field">
              <div className="event-profile-field-name">
                {i18nTranslate(field.label, 'Profile Information')}
              </div>
              <div className="event-profile-field-value">{field.value}</div>
            </div>
          ))}
      </div>
    )
  }

  renderAccountType = () => {
    return (
      <div className="event-profile-account-type">
        <h1 className="event-profile-title">
          {i18nTranslate('accounts.accountTypeHeading', 'Account Type')}
        </h1>
        {this.dataForEventAccountProfile &&
          this.dataForEventAccountProfile.map(field => (
            <div className="event-profile-field">
              <div className="event-profile-field-name">
                {i18nTranslate(field.label, 'Profile Information')}
              </div>
              <div className="event-profile-field-value">{field.value}</div>
            </div>
          ))}
      </div>
    )
  }

  renderEditInfo = () => {
    return (
      <div className="event-profile-edit-info">
        {i18nTranslate(
          'event.editLocationInfo',
          'This information can be edited at '
        )}
        <a
          className="event-profile-edit-link"
          href="https://www.nuskin.com/us/en/"
          target="_blank"
          rel="noopener noreferrer">
          nuskin.com
        </a>
      </div>
    )
  }

  render() {
    return (
      <Card className="mb-3 shadow-sm">
        <Card.Body className="bg-white">
          {this.renderAccountInformation()}
          {this.renderAccountType()}
        </Card.Body>
      </Card>
    )
  }
}

export default EventStaticAccountProfile
